import {createSlice} from '@reduxjs/toolkit';
import {setNewWorkingHoursPerDay, setNewTimezone, setWorkingHours} from './actions';
import {initialState} from './initialState';
import {updateTimeForAllWeekDays} from './utils';

const slice = createSlice({
  name: 'workingHours',
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(setNewTimezone, (state, action) => {
        if (!state) {
          return;
        }
        state.timeZoneId = action.payload;
      })
      .addCase(setNewWorkingHoursPerDay, (state, action) => {
        if (!state) {
          return;
        }
        const {newTime, dayName, timeslot} = action.payload;

        if (!dayName) {
          state.days = updateTimeForAllWeekDays(state.days, newTime);
          return;
        }
        const selectedDay = state.days.find((day) => day.dayName === dayName)!;

        selectedDay.times[timeslot] = {...selectedDay.times[timeslot], ...newTime};
      })
      .addCase(setWorkingHours, (_, action) => {
        return action.payload;
      });
  },
});

export default slice.reducer;
